// CreateResponsablePage.tsx
import { SaveResponsable } from "../../components";

export default function CreateResponsablePage() {
  return <SaveResponsable titulo="Crear Responsable" />;
}
